module.exports = __webpack_public_path__ + "static/media/green_jesse_face.9de49d1e.png";